'use client'

import { useEffect, useState } from "react"
import { DMProvider } from "@dealermesh/react"
import ApiUtils from "@/utils/ApiUtils"

export default function Dealermesh(props) {
  
  const site = props.site
  const [dmConfig,setDmConfig] = useState()
  const [initilized,setInitialized] = useState(false)
  
  useEffect(() => {
    if (!site.isBot && site.api_keys.dm_client_id) {
      ApiUtils.getRequest("/api/dealermesh").then(data => {
        // console.log("---- DEALERMESH", data)
        if (data.access_token) {
          setDmConfig({
            server: process.env.NODE_ENV == 'development' ? "http://localhost:3002" : null,
            clientId: data.client_id,
            accessToken: data.access_token,
            accessKey: data.access_key,
            page: site.page_name || site.list_name
          })
          setInitialized(true)
        }
      })
    }
  }, [])
  
  if (dmConfig && initilized) {
    return <DMProvider config={dmConfig} visitorId={site.vid}></DMProvider>
  } else {
    return <></>
  }
  
}